import React, { Component } from "react";
import { useState } from "react";
import CartContext from "./CartContext";
import { SideMenu } from "./SideMenu";
import Fuse from "fuse.js";
import { BiSave, BiRefresh, BiUpload, BiDownload } from "react-icons/bi";
import { BsFillPencilFill, BsFillPrinterFill } from "react-icons/bs";

import {
  Nav,
  FloatingLabel,
  Stack,
  FormControl,
  InputGroup,
  Table,
  OverlayTrigger,
  Tooltip,
  Navbar,
  Card,
} from "react-bootstrap";
import { Button, ButtonToolbar, Form, Row, Col } from "react-bootstrap";

/* ======= OutOfStock (responsive) ======= */
export class OutOfStock extends Component {
  static contextType = CartContext;
  constructor(props) {
    super(props);
    this.state = {
      prods: [],
      selectedMainCategoryId: "1",
      selectedMainCategoryName: "All",
      selectedSubCategoryId: "0",
      selectedSubCategoryName: "All",
      filteredProducts: [],
      filteredProductsCopy: [],
      searchData: [],
      searchquery: "",
      reload: true,
      instockRequired: 10,
      instockRequiredMin: 0,
      instockRequiredMax: 20,
      isDesktop: window.innerWidth >= 900,
    };

    this.handleResize = this.handleResize.bind(this);
  }

  handleResize() {
    const isDesktop = window.innerWidth >= 900;
    if (isDesktop !== this.state.isDesktop) this.setState({ isDesktop });
  }

  componentDidMount() {
    window.addEventListener("resize", this.handleResize);
    this.setState(
      {
        selectedMainCategoryId:
          this.context.mainCategories.length > 0
            ? this.context.mainCategories[0].id
            : "0",
      },
      () => {
        this.onCategoryChanges();
      }
    );
    window.scrollTo(0, 0);
  }

  componentWillUnmount() {
    window.removeEventListener("resize", this.handleResize);
  }

  GetPurchaseRequestHTML = () => {
    var str = "<html>";
    str += '<div style="width: 100%;text-align: center">';
    str +=
      "<h4><u>" +
      "Out-Of-Stock" +
      "</u>" +
      " [" +
      this.context.GetInDateFormat(new Date()) +
      " ]</h4>";
    str += "<h4>" + this.context.store.name + "</h4>";
    str += "</div>";

    str += '<table style="width: 100%;border:dashed;text-align:start">';
    str +=
      '<thead ><th></th><th style="text-align:start">ItemName</th><th style="text-align:start">InStockQty</th></thead>';

    var oos = this.state.filteredProducts.filter(
      (prod) =>
        (prod.productVariantType == 1 &&
          prod.inStockQty >= Number(this.state.instockRequiredMin) &&
          prod.inStockQty <= Number(this.state.instockRequiredMax)) ||
        (prod.productVariantType == 2 &&
          this.IsMultiVariantProductOutOfStock(prod))
    );

    oos.map((item, i) => {
      str +=
        "<tr><td>" +
        (i + 1) +
        "</td>" +
        "<td>" +
        item.name +
        "</td>" +
        "<td>" +
        item.inStockQty +
        "</td></tr>";
    });
    str += "</table></html>";

    return str;
  };

  PrintMe = (invoiceHtml) => {
    var printWindow = window.open("", "_blank");
    printWindow.document.write(this.GetPurchaseRequestHTML());
    printWindow.document.close();
    this.onPrintFinished(printWindow.print(), printWindow);
  };
  onPrintFinished = (status, printWindow) => {
    var osvar = this.getOS();
    if (osvar == "Windows") printWindow.close();
  };
  getOS = () => {
    var uA = navigator.userAgent || navigator.vendor || window.opera;
    if (
      (/iPad|iPhone|iPod/.test(uA) && !window.MSStream) ||
      (uA.includes("Mac") && "ontouchend" in document)
    )
      return "iOS";

    var i,
      os = ["Windows", "Android", "Unix", "Mac", "Linux", "BlackBerry"];
    for (i = 0; i < os.length; i++)
      if (new RegExp(os[i], "i").test(uA)) return os[i];
  };

  onMainCategorySelectChangeEvent = (e) => {
    this.setState({ reload: false });
    this.setState({ selectedMainCategoryId: e.target.value }, () => {
      this.setState({ selectedSubCategoryId: "0" }, () =>
        this.OnSubCategoryIDChanges()
      );
    });
  };
  OnSubCategoryIDChanges = () => {
    this.onCategoryChanges();
  };

  onSubCategorySelectChangeEvent = (e) => {
    this.setState({ reload: false });
    this.setState({ selectedSubCategoryId: e.target.value }, () =>
      this.onCategoryChanges()
    );
  };
  onFilteredProductsChanged = () => {
    this.setState({ filteredProductsCopy: this.state.filteredProducts }, () => {
      this.setState({ reload: true });
      console.log("products reloaded");
    });
  };
  onCategoryChanges = () => {
    // when main and sub are "All"
    if (
      this.state.selectedMainCategoryId === "0" &&
      this.state.selectedSubCategoryId === "0"
    ) {
      this.setState(
        {
          filteredProducts: JSON.parse(JSON.stringify([...this.context.prods])),
        },
        () => this.onFilteredProductsChanged()
      );
    }
    // main is not ALL, sub is ALL
    else if (
      this.state.selectedMainCategoryId !== "0" &&
      this.state.selectedSubCategoryId === "0"
    ) {
      this.setState(
        {
          filteredProducts: JSON.parse(
            JSON.stringify(
              this.context.prods.filter((prod) => {
                return (
                  prod.subCategory.mainCategoryId ===
                  this.state.selectedMainCategoryId
                );
              })
            )
          ),
        },
        () => this.onFilteredProductsChanged()
      );
    }
    // both main and sub not ALL
    else {
      this.setState(
        {
          filteredProducts: JSON.parse(
            JSON.stringify(
              this.context.prods.filter((prod) => {
                return (
                  prod.subCategory.mainCategoryId ===
                    this.state.selectedMainCategoryId &&
                  prod.subCategory.id === this.state.selectedSubCategoryId
                );
              })
            )
          ),
        },
        () => this.onFilteredProductsChanged()
      );
    }
  };

  onSearchChange = (query) => {
    this.setState({ reload: false });
    this.setState({ searchquery: query });
    if (!query) {
      this.setState(
        { filteredProducts: this.state.filteredProductsCopy },
        () => {
          this.setState({ reload: true });
        }
      );
      return;
    }
    const fuse = new Fuse(this.state.filteredProducts, {
      keys: ["name"],
      threshold: 0.6,
    });
    const result = fuse.search(query);
    const finalResult = [];
    if (result.length) {
      result.forEach((item) => {
        finalResult.push(item.item);
      });
      this.setState({ filteredProducts: finalResult.slice(0, 15) }, () => {
        this.setState({ reload: true });
      });
    } else {
      this.setState({ filteredProducts: [] });
    }
  };
  OnRefreshButtonClick = () => {
    this.setState({ reload: false }, () => {
      this.onCategoryChanges();
    });
  };

  useForceUpdate = () => {
    const [value, setValue] = useState(0); // integer state
    return () =>
      setValue(
        (value) => value + 1,
        () => {}
      ); // update the state to force render
  };

  IsMultiVariantProductOutOfStock = (prod) => {
    var result = prod.productCustomFields.filter(
      (f) =>
        f.inStockQty <= this.state.instockRequiredMin &&
        f.inStockQty >= this.state.instockRequiredMax
    );
    if (result.length > 0) return true;
    else return false;
  };

  renderFilters = () => {
    return (
      <div style={{ marginBottom: "1rem" }}>
        <Row className="gy-2 gx-2 align-items-center">
          {/* Min Qty */}
          <Col xs={6} sm={3}>
            <Form.Group controlId="flt-min-qty">
              <Form.Label style={{ fontSize: 12, fontWeight: 600 }}>
                Min Qty
              </Form.Label>
              <Form.Control
                type="number"
                min={0}
                placeholder="Min"
                value={this.state.instockRequiredMin}
                onChange={(e) =>
                  this.setState({ instockRequiredMin: e.target.value })
                }
                size="sm"
              />
            </Form.Group>
          </Col>

          {/* Max Qty */}
          <Col xs={6} sm={3}>
            <Form.Group controlId="flt-max-qty">
              <Form.Label style={{ fontSize: 12, fontWeight: 600 }}>
                Max Qty
              </Form.Label>
              <Form.Control
                type="number"
                min={0}
                placeholder="Max"
                value={this.state.instockRequiredMax}
                onChange={(e) =>
                  this.setState({ instockRequiredMax: e.target.value })
                }
                size="sm"
              />
            </Form.Group>
          </Col>

          {/* Main Category */}
          <Col xs={6} sm={3}>
            <Form.Group controlId="flt-main-cat">
              <Form.Label style={{ fontSize: 12, fontWeight: 600 }}>
                Main Category
              </Form.Label>
              <Form.Select
                aria-label="Main Category"
                value={this.state.selectedMainCategoryId}
                onChange={(e) => this.onMainCategorySelectChangeEvent(e)}
                size="sm"
              >
                <option value={0}>All</option>
                {this.context.mainCategories.map((c) => (
                  <option key={c.id} value={c.id}>
                    {c.name}
                  </option>
                ))}
              </Form.Select>
            </Form.Group>
          </Col>

          {/* Sub Category */}
          <Col xs={6} sm={3}>
            <Form.Group controlId="flt-sub-cat">
              <Form.Label style={{ fontSize: 12, fontWeight: 600 }}>
                Sub Category
              </Form.Label>
              <Form.Select
                aria-label="Sub Category"
                value={this.state.selectedSubCategoryId}
                onChange={(e) => this.onSubCategorySelectChangeEvent(e)}
                size="sm"
              >
                <option value={0}>All</option>
                {this.context.subCategories
                  .filter(
                    (s) =>
                      s.mainCategoryId === this.state.selectedMainCategoryId
                  )
                  .map((s) => (
                    <option key={s.id} value={s.id}>
                      {s.name}
                    </option>
                  ))}
              </Form.Select>
            </Form.Group>
          </Col>
        </Row>
      </div>
    );
  };

  renderSearch() {
    return (
      <div style={{ marginBottom: ".8rem" }}>
        <Stack direction="horizontal" gap={3} className="">
          <b>
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="20"
              height="20"
              fill="currentColor"
              className="bi bi-search"
              viewBox="0 0 16 16"
            >
              <path d="M11.742 10.344a6.5 6.5 0 1 0-1.397 1.398h-.001c.03.04.062.078.098.115l3.85 3.85a1 1 0 0 0 1.415-1.414l-3.85-3.85a1.007 1.007 0 0 0-.115-.1zM12 6.5a5.5 5.5 0 1 1-11 0 5.5 5.5 0 0 1 11 0z" />
            </svg>
          </b>
          <FormControl
            type="search"
            placeholder="Search... "
            className="text-primary fw-bold bg-white "
            size="lg"
            aria-label="Search"
            onChange={(e) => this.onSearchChange(e.target.value)}
          />
        </Stack>
      </div>
    );
  }

  renderTableHeader() {
    if (this.state.isDesktop) {
      return (
        <thead className="text-start">
          <tr className="text-start text-black bg-white border">
            <th className="text-center" width="10%"></th>
            <th className="text-start" width="20%">
              Name
            </th>

            <th width="20%">Category</th>
            <th width="10%">Price</th>
            <th width="10%">Discount(%)</th>
            <th width="10%">S.Price</th>
            {/* <th width="10%">ProductVariant</th> */}
            <th width="10%">In-Stock</th>
          </tr>
        </thead>
      );
    }

    return (
      <thead className="text-center">
        <tr className="text-center text-black bg-white border">
          {/* <th></th> */}
          <th className="text-center">Name</th>
          {/* <th className="text-center">ProductVariant</th> */}
          <th>Price</th>
          <th>Disc %</th>
          <th>S.Price</th>
          <th>In-Stock</th>
        </tr>
      </thead>
    );
  }

  render() {
    const rows = this.state.filteredProducts.map((prod, i) => {
      const visible =
        this.state.reload === true &&
        ((prod.productVariantType == 1 &&
          prod.inStockQty >= Number(this.state.instockRequiredMin) &&
          prod.inStockQty <= Number(this.state.instockRequiredMax)) ||
          (prod.productVariantType == 2 &&
            this.IsMultiVariantProductOutOfStock(prod)));
      return visible ? (
        <ShowOutOfStockProductsInline
          key={prod.id || i}
          index={i}
          prod={prod}
        />
      ) : null;
    });

    return (
      <>
        {/* small inline CSS for quick drop-in; move to stylesheet if you prefer */}
        <style></style>

        <div className="Container-fluid mx-0 p-0 pagebackground">
          <div className="Container-fluid m-0 p-0 ">
            <Navbar className="shadow position-sticky fixed-top py-3 text-black ">
              <h3>
                <b>Product InStock Checker</b> &nbsp;
              </h3>
            </Navbar>

            <div className="purposestyle">
              {" "}
              <b>Purpose:</b> Use this Module to find items which are between
              Instock Range. Use "Minimum & Maximum In-Stock range" to find
              results.
            </div>

            <div className="p-3">
              {this.renderFilters()}
              {this.renderSearch()}

              <div className="text-center p-3 w-100 text-black">
                <Row>
                  <Col className="text-start">
                    <h3>Results</h3>
                  </Col>
                  <Col className="text-end">
                    {this.state.filteredProducts.length > 0 && (
                      <Button onClick={this.PrintMe}>
                        <BsFillPrinterFill size={20} /> &nbsp;&nbsp;Print
                      </Button>
                    )}
                  </Col>
                </Row>

                {/* responsive table wrapper for desktop */}
                <div className="table-responsive">
                  <Table border striped className="px-0">
                    {this.renderTableHeader()}
                    <tbody className="text-primary border">{rows}</tbody>
                  </Table>
                </div>
              </div>
            </div>
          </div>
        </div>
      </>
    );
  }
}

/* ======= ShowOutOfStockProductsInline (responsive rendering) ======= */
export class ShowOutOfStockProductsInline extends Component {
  static contextType = CartContext;
  constructor(props) {
    super(props);
    this.state = {
      prod: this.props.prod,
    };
  }

  componentDidMount() {}

  getMainCategoryId = (subCategoryId) => {
    var mainCategoryId = "";
    return this.context.subCategories
      .filter((e) => e.id === subCategoryId)
      .map((t) => (mainCategoryId = t.mainCategoryId));
    return mainCategoryId;
  };

  render() {
    const p = this.state.prod;
    const isDesktop = window.innerWidth >= 900;

    if (isDesktop) {
      return (
        <tr
          className="text-start align-middle text-secondary bg-white mx-5"
          style={{ fontSize: "12px" }}
        >
          <td className="text-center ">
            {p.productImages.length > 0 ? (
              <img
                src={
                  this.context.store.storageBlobUrl +
                  this.context.store.storageBlobContainerName +
                  "/images/" +
                  p.productImages[0].fileName +
                  this.context.store.storageSasToken
                }
                className="mx-auto CornersRounded"
                width="50px"
                alt="..."
              />
            ) : null}
          </td>
          <td>{p.name}</td>

          <td>
            {p.subCategory.name}
            &nbsp;[
            {this.context.getMainCategoryName(p.subCategory.mainCategoryId)}]
          </td>
          {p.productVariantType == 2 ? (
            <>{/* <td colSpan={4}></td> */}</>
          ) : (
            <>
              <td className="">
                {Number(p.mrp).toLocaleString(
                  this.context.storeSettings.defaultLocale,
                  {
                    minimumFractionDigits: 0,
                    maximumFractionDigits: 1,
                    style: "currency",
                    currency: this.context.storeSettings.defaultCurrency,
                  }
                )}
              </td>
              <td>{p.discount}</td>
              <td>
                <h6 className="fw-bold text-dark">
                  {Math.round(
                    p.mrp - (p.mrp * p.discount) / 100,
                    0
                  ).toLocaleString(this.context.storeSettings.defaultLocale, {
                    minimumFractionDigits: 0,
                    maximumFractionDigits: 1,
                    style: "currency",
                    currency: this.context.storeSettings.defaultCurrency,
                  })}
                </h6>
              </td>
              {/* <td>{p.productVariantType == 1 ? "Single" : "Multiple"}</td> */}
              <td>
                <h3>{p.inStockQty}</h3>
              </td>
            </>
          )}
        </tr>
      );
    }

    /* mobile: we don't return a table row here because mobile grid uses cards above.
       To keep table body valid when mobile still uses table rendering, return a compact TR fallback */
    return (
      <tr
        className="text-center align-middle text-secondary bg-white mx-1"
        style={{ fontSize: "12px" }}
      >
        {/* <td>{this.props.index + 1}</td> */}
        <td className="col-md-3 text-start ">
          {/* {p.productImages?.length > 0 ? (
            <img
              style={{ width: 30, height: 30 }}
              src={
                this.context.store.storageBlobUrl +
                this.context.store.storageBlobContainerName +
                "/images/" +
                p.productImages[0].fileName +
                this.context.store.storageSasToken
              }
              className="productimg-on-productlist mx-auto"
              alt="..."
            />
          ) : (
            <div style={{ width: 30, height: 30 }} />
          )} */}
          &nbsp;{p.name}
        </td>
        {/* <td>{p.productVariantType == 1 ? "Single" : "Multiple"}</td> */}
        <td className="text-center align-middle">{p.mrp}</td>
        <td>{p.discount}</td>
        <td>
          <h6 className="fw-bold text-dark">
            {Math.round(p.mrp - (p.mrp * p.discount) / 100, 0)}
          </h6>
        </td>
        <td>
          <h3>{p.inStockQty}</h3>
        </td>
      </tr>
    );
  }
}
